module.exports = __webpack_public_path__ + "static/DataProvider-f0a447e206cc28e25b5089d922ebe1c7.png";